export default __webpack_public_path__ + "static/media/eye_no.303a4f8e.svg";